module.exports = __webpack_public_path__ + "img/Rectangle 10302.09de95cb.svg";